import { UploadFile } from 'antd/es/upload/interface';

import { DEFAULT_UPLOAD_FILE_MAX_SIZE_BYTES, DEFAULT_UPLOAD_FILE_MAX_SIZE_MB } from 'constants/files';
import { convertToBase64 } from 'utils/helpers/files';

export const getUploadFileList = (event: { fileList?: UploadFile[] } | UploadFile[]) => {
  if (Array.isArray(event)) {
    return event;
  }

  return event?.fileList ?? [];
};

export const isFileWithinSizeLimit = (file: UploadFile | File) => {
  if (file instanceof File) {
    return file.size <= DEFAULT_UPLOAD_FILE_MAX_SIZE_BYTES;
  }

  if (!(file.originFileObj instanceof File)) {
    return true;
  }

  return file.originFileObj.size <= DEFAULT_UPLOAD_FILE_MAX_SIZE_BYTES;
};

export const getFileSizeLimitErrorMessage = (fileName: string) =>
  `${fileName} must be ${DEFAULT_UPLOAD_FILE_MAX_SIZE_MB} MB or smaller.`;

export const getOversizedUploadFile = (files: UploadFile[] = []) => files.find((file) => !isFileWithinSizeLimit(file));

export const buildCommunicationLogFilePayload = async (files: UploadFile[] = []) =>
  Promise.all(
    files
      .filter((file) => file.originFileObj instanceof File)
      .map(async (file) => ({
        name: file.name,
        file: {
          name: file.name,
          data: await convertToBase64(file.originFileObj as File),
        },
      }))
  );
